import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import AutoGrowInput from './AutoGrowInput';

/**
 * NodeView درون‌خطی توان/اندیس — مثل Equation ورد.
 *
 * چیدمان flex: [پایه][توان در بالا / اندیس در پایین]
 * موقعیت مربع خالی و متن با جابه‌جایی کانتینر والد AutoGrowInput تنظیم می‌شود
 * تا مربع خط‌چین و متن هر دو دقیقاً در جای درست (توان بالا / اندیس پایین) قرار گیرند.
 */
const PowerNodeView = ({ node, updateAttributes, selected }) => {
  const isSub = node.type.name === 'subscript';
  const { base = '', exp = '', sub = '' } = node.attrs;

  return (
    <NodeViewWrapper
      as="span"
      className={`relative inline-block align-middle mx-1 rounded transition-all ${
        selected ? 'bg-blue-50/40 ring-2 ring-blue-400' : ''
      }`}
      style={{ direction: 'ltr', unicodeBidi: 'isolate' }}
    >
      <span
        className="inline-flex items-center"
        contentEditable={false}
        style={{
          columnGap: '2px',
          verticalAlign: 'middle',
          paddingTop: isSub ? '0px' : '0.3em',
          paddingBottom: isSub ? '0.35em' : '0px',
        }}
      >
        <AutoGrowInput
          value={base}
          onCommit={(v) => updateAttributes({ base: v })}
          aria-label="پایه"
          className="border-b border-transparent focus:border-blue-400"
        />
        {isSub ? (
          <span
            style={{
              fontSize: '0.82em',
              transform: 'translateY(0.40em)',
              display: 'inline-flex',
            }}
          >
            <AutoGrowInput
              value={sub}
              onCommit={(v) => updateAttributes({ sub: v })}
              aria-label="اندیس"
              className="border-b border-transparent focus:border-blue-400"
            />
          </span>
        ) : (
          <span
            style={{
              fontSize: '0.82em',
              transform: 'translateY(-0.45em)',
              display: 'inline-flex',
            }}
          >
            <AutoGrowInput
              value={exp}
              onCommit={(v) => updateAttributes({ exp: v })}
              aria-label="توان"
              className="border-b border-transparent focus:border-blue-400"
            />
          </span>
        )}
      </span>
    </NodeViewWrapper>
  );
};

export default PowerNodeView;
